<div class="content-box">
  <section class="cadastro" aria-labelledby="cadastro-titulo">
    <app-breadcrumb pagina="Cadastro"></app-breadcrumb>

    <div class="cadastro-cabecalho">
      <div>
        <h1 class="cadastro-titulo" id="cadastro-titulo">Cadastro</h1>
        <p class="cadastro-subtitulo">Siga as orientações abaixo para realizar seu cadastro eficiente.</p>
      </div> 
    </div>

    <div class="cadastro-progresso">
      <div class="cadastro-progresso-topo">
        <h2 class="cadastro-progresso-titulo">Progresso do cadastro</h2>
        <span class="cadastro-progresso-total">{{ progressoTotal() }}%</span>
      </div>

      <ol class="cadastro-etapas">
        @for (percentual of progressoEtapas(); track $index) {
        <li class="cadastro-etapa" [class.cadastro-etapa-ativa]="percentual > 0">
          <div class="cadastro-etapa-topo">
            <span class="cadastro-etapa-nome">Etapa {{ $index + 1 }}</span>
            <span class="cadastro-etapa-percentual">{{ percentual }}%</span>
          </div>

          <div class="cadastro-etapa-barra" role="progressbar" [attr.aria-valuenow]="percentual" aria-valuemin="0"
            aria-valuemax="100" [attr.aria-label]="'Preenchimento da etapa ' + ($index + 1)">
            <span class="cadastro-etapa-preenchido" [style.width.%]="percentual"></span>
          </div>
        </li>
        }
      </ol>
    </div>

    <h2 class="cadastro-chamada">Estamos quase lá!</h2>
    <p class="cadastro-chamada-texto">
      Agora é só preencher o formulário abaixo para realizar o cadastro dos serviços e acompanhamento. Simples assim!
    </p>

    <p class="cadastro-legenda-obrigatorio">
      <span class="cadastro-obrigatorio" aria-hidden="true">*</span>
      Campos obrigatórios
    </p>

    <form class="cadastro-formulario" (submit)="continuar($event)">
      <fieldset class="cadastro-bloco">
        <legend class="cadastro-bloco-titulo">Informações pessoais</legend>

        <div class="cadastro-grade cadastro-grade-2">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="nome-completo">Nome completo<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="nome-completo" class="cadastro-input" aria-required="true" type="text" autocomplete="name"
              placeholder="Digite seu nome completo" [formField]="cadastroForm.nomeCompleto" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="nome-social">Nome social</label>
            <input id="nome-social" class="cadastro-input" type="text" placeholder="Digite seu nome social"
              [formField]="cadastroForm.nomeSocial" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="genero">Gênero<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <select id="genero" class="cadastro-input" aria-required="true" [formField]="cadastroForm.genero">
              <option value="">Selecione</option>
              @for (genero of generos; track genero) {
              <option [value]="genero">{{ genero }}</option>
              }
            </select>
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="raca-cor">Raça/Cor<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <select id="raca-cor" class="cadastro-input" aria-required="true" [formField]="cadastroForm.racaCor">
              <option value="">Selecione</option>
              @for (raca of racasCores; track raca) {
              <option [value]="raca">{{ raca }}</option>
              }
            </select>
          </div>
        </div>

        <div class="cadastro-grade cadastro-grade-3">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="data-nascimento">Data de nascimento<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="data-nascimento" class="cadastro-input" aria-required="true" type="date" autocomplete="bday"
              [formField]="cadastroForm.dataNascimento" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="rg">RG<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="rg" class="cadastro-input" aria-required="true" type="text" placeholder="Digite seu RG"
              [formField]="cadastroForm.rg" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="cpf">CPF<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="cpf" class="cadastro-input" aria-required="true" type="text" inputmode="numeric" placeholder="000.000.000-00"
              [formField]="cadastroForm.cpf" />
          </div>
        </div>

        <div class="cadastro-campo">
          <label class="cadastro-rotulo" for="dependentes">Dependentes</label>
          <input id="dependentes" class="cadastro-input" type="number" inputmode="numeric"
            placeholder="Informe quantos dependentes" [formField]="cadastroForm.dependentes" />
        </div>
      </fieldset>

      <fieldset class="cadastro-bloco">
        <legend class="cadastro-bloco-titulo">Endereço Residencial</legend>

        <div class="cadastro-grade cadastro-grade-endereco">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="endereco-completo">Endereço completo<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="endereco-completo" class="cadastro-input" aria-required="true" type="text" autocomplete="street-address"
              placeholder="Rua, avenida, etc." [formField]="cadastroForm.enderecoCompleto" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="numero">Número<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="numero" class="cadastro-input" aria-required="true" type="text" placeholder="Nº" [formField]="cadastroForm.numero" />
          </div>
        </div>

        <div class="cadastro-grade cadastro-grade-3">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="complemento">Complemento</label>
            <input id="complemento" class="cadastro-input" type="text" placeholder="Apto, bloco, etc."
              [formField]="cadastroForm.complemento" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="cep">CEP<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="cep" class="cadastro-input" aria-required="true" type="text" inputmode="numeric" autocomplete="postal-code"
              placeholder="00000-000" [formField]="cadastroForm.cep" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="bairro">Bairro<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="bairro" class="cadastro-input" aria-required="true" type="text" placeholder="Digite o bairro"
              [formField]="cadastroForm.bairro" />
          </div>
        </div>

        <div class="cadastro-grade cadastro-grade-2">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="estado">Estado<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <select id="estado" class="cadastro-input" aria-required="true" [formField]="cadastroForm.estado">
              <option value="">Selecione</option>
              @for (estado of estados; track estado) {
              <option [value]="estado">{{ estado }}</option>
              }
            </select>
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="cidade">Cidade<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <select id="cidade" class="cadastro-input" aria-required="true" [formField]="cadastroForm.cidade">
              <option value="">Selecione</option>
              @for (cidade of cidades(); track cidade) {
              <option [value]="cidade">{{ cidade }}</option>
              }
            </select>
          </div>
        </div>
      </fieldset>

      <fieldset class="cadastro-bloco">
        <legend class="cadastro-bloco-titulo">Contatos</legend>

        <div class="cadastro-grade cadastro-grade-2">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="email">E-mail<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="email" class="cadastro-input" aria-required="true" type="email" autocomplete="email" placeholder="nome@exemplo.com"
              [formField]="cadastroForm.email" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="senha">Senha<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="senha" class="cadastro-input" aria-required="true" type="password" autocomplete="new-password" placeholder="••••••••"
              [formField]="cadastroForm.senha" />
          </div>
        </div>

        <div class="cadastro-grade cadastro-grade-3">
          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="telefone-residencial">Telefone residencial</label>
            <input id="telefone-residencial" class="cadastro-input" type="tel" placeholder="(00) 0000-0000"
              [formField]="cadastroForm.telefoneResidencial" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="telefone-celular-01">Telefone celular 01<span class="cadastro-obrigatorio" aria-hidden="true">*</span></label>
            <input id="telefone-celular-01" class="cadastro-input" aria-required="true" type="tel" autocomplete="tel"
              placeholder="(00) 00000-0000" [formField]="cadastroForm.telefoneCelular01" />
          </div>

          <div class="cadastro-campo">
            <label class="cadastro-rotulo" for="telefone-celular-02">Telefone celular 02</label>
            <input id="telefone-celular-02" class="cadastro-input" type="tel" placeholder="(00) 00000-0000"
              [formField]="cadastroForm.telefoneCelular02" />
          </div>
        </div>
      </fieldset>

      @if (preenchido() && pendencias().length) {
        <div class="cadastro-pendencias" id="cadastro-pendencias" role="status" aria-live="polite">
          <p class="cadastro-pendencias-titulo">Para concluir o cadastro:</p>
          <ul class="cadastro-pendencias-lista">
            @for (pendencia of pendencias(); track pendencia) {
              <li>{{ pendencia }}</li>
            }
          </ul>
        </div>
      }

      <div class="cadastro-alerta" role="note">
        <span class="cadastro-alerta-icone" aria-hidden="true">
          <i-lucide name="mail" size="18"></i-lucide>
        </span>

        <div>
          <p class="cadastro-alerta-titulo">Confirmação de envio de e-mail</p>
          <p class="cadastro-alerta-texto">
            Após concluir o cadastro, enviaremos um e-mail de confirmação para o endereço informado.
            Verifique sua caixa de entrada (e a pasta Spam/Lixo Eletrônico) para confirmar seu acesso.
          </p>
        </div>
      </div>

      <div class="cadastro-acoes">
        <button type="button" class="cadastro-botao cadastro-botao-voltar" (click)="voltar()">
          <i-lucide name="arrow-left" size="16" aria-hidden="true"></i-lucide>
          Voltar
        </button>

        <button
          type="submit"
          class="cadastro-botao cadastro-botao-continuar"
          [disabled]="!podeEnviar()"
          [attr.aria-describedby]="podeEnviar() ? null : 'cadastro-pendencias'"
        >
          Continuar
          <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
        </button>
      </div>
    </form>
  </section>
</div>